import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const container = document.getElementById('root');

const drzewo = (
  <React.StrictMode>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </React.StrictMode>
);

/*
 * UWAGA - dlaczego tu jest createRoot, a nie hydrateRoot.
 *
 * Kazda trasa jest prerenderowana do build/<trasa>/index.html, wiec kuszace jest
 * przejecie gotowego DOM-u przez hydrateRoot (obrazki ruszylyby w trakcie
 * parsowania, a nie po starcie Reacta). Sprawdzone 2026-07-27: hydracja
 * wywraca sie na KAZDEJ trasie (React #425 "Text content does not match",
 * potem #418 i #423), React i tak przebudowuje cale drzewo od zera - czyli
 * robi wiecej pracy niz createRoot, a do konsoli leca cztery bledy.
 *
 * Powod: prerender zapisuje DOM zrzucony PO wykonaniu efektow (chrome
 * --dump-dom), a hydracja porownuje go z PIERWSZYM renderem, przed efektami.
 * Zeby wlaczyc hydracje, prerender musialby zapisywac stan pierwszego renderu
 * (albo stan po efektach musialby byc identyczny z poczatkowym).
 * Do czasu takiej zmiany createRoot jest szybszym i cichszym wyborem.
 */
ReactDOM.createRoot(container).render(drzewo);

reportWebVitals();
